import { baseStoreCreator } from '@common-fe/common-fe';

import { IFileTypeDtoFileTypeEnum } from '@/types';

export interface FileManagerSettingsState {
  isFileManagerAccessEnabled?: boolean;
  isFileAutoPostEnabled?: boolean | string;

  allowedFileTypes?: IFileTypeDtoFileTypeEnum[];
  duplicateCheckFileTypes?: IFileTypeDtoFileTypeEnum[];
  isSendFiles: boolean;
  fileLocation?: string;
  isAutoFileLocation?: boolean;
  isSameErrorReportLocation?: boolean;
  errorReportLocation?: string;
}

export const DEFAULT_VALUES: FileManagerSettingsState = {
  isFileManagerAccessEnabled: undefined,
  isFileAutoPostEnabled: undefined,
  allowedFileTypes: [],
  duplicateCheckFileTypes: [],
  isSendFiles: false,
  fileLocation: '',
  isAutoFileLocation: false,
  isSameErrorReportLocation: undefined,
  errorReportLocation: '',
};

export const useStore = baseStoreCreator<FileManagerSettingsState>(DEFAULT_VALUES);

export default useStore;
